import { UserState } from '.'

export const getUserEmail = (user: UserState): string => user.email
